import React, {useRef} from 'react'
import styles from '../componentsStyles/Projects.module.css'

import {useScroll, motion, useTransform} from 'framer-motion'


function ProjectImages() {

  const imageRef = useRef(null);


  const {scrollYProgress} = useScroll({
    target:imageRef,
    offset: ["start end", "start start"]
  })

  const scale = useTransform(scrollYProgress, 
    [0.1, 0.4],
    [1, 1.5]
  )

  const x = useTransform(scrollYProgress,  
  [0.1, 0.55, 0.7, 1],
  ["0%", "-55%", "-65%", "-70%"]
  )

  const opacity = useTransform(scrollYProgress,
  [0.5, 1],[0, 1]
  )

  const leftRigth1 = useTransform(scrollYProgress, 
    [0.25, 0.50, 0.75, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )
  const leftRigth2 = useTransform(scrollYProgress, 
    [0.35, 0.65, 0.85, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )
  const leftRigth3 = useTransform(scrollYProgress, 
    [0.45, 0.75, 0.85, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )




  return (
    <div className={styles.image}> 
        
        <div className={styles.heightContainer} >
            <div className={styles.stickyContainer} ref={imageRef}>
              <div className={styles.centerImg}>
                <motion.div className={styles.imgContainer} style={{x,scale}}>
                    <img src="./images/task-handler-1.jpg" alt="not loaded!"  />
                </motion.div>
              </div>
              
            </div>

            <motion.div className={styles.desc} style={{opacity, x: -105}}>
              <h3> Task handler app </h3>
              <motion.p style={{x: leftRigth1}}> 
               User authentication features, where the user kepps track of every change on the task.
              </motion.p>
              <motion.p style={{x: leftRigth2}}>
               Task creation, tied to deadlines, description and task progress status.
              </motion.p>
              <motion.p style={{x: leftRigth3}}>
                Teams creation, assosited with any speciic task, also fallowed by status and some other informtions
              </motion.p>
              

       

            </motion.div>
      
        </div>

    </div>
  )
}

export default ProjectImages